import { render, staticRenderFns } from "./ConvertToDesktopModal.vue?vue&type=template&id=7ac8e036&"
import script from "./ConvertToDesktopModal.vue?vue&type=script&lang=js&"
export * from "./ConvertToDesktopModal.vue?vue&type=script&lang=js&"
import style0 from "./ConvertToDesktopModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports